const getTagArrayForObject = (object) => {
  return Array.isArray(object.tags)
    ? object.tags
    : getTagArrayFromString(object.tags);
};

const getTagArrayFromString = (tagString) => {
  return tagString?.length > 1 ? `${tagString || ''}`.split(',') : [];
};
export const getTagValue = (object, tagName) => {
  if (!object) return false;
  let tagList = getTagArrayForObject(object);
  return tagList
    .filter((tag) => tag.startsWith(`${tagName}:`))
    .map((te) => te.split(':')[1].trim())
    .join(',');
};

export const setTagValue = (object, tagName, tagValue) => {
  if (tagValue === getTagValue(object, tagName)) {
    return object.tags;
  }
  let tagList = getTagArrayForObject(object);
  let filteredTagList = tagList.filter((tag) => !tag.startsWith(`${tagName}:`));
  if (!tagValue) {
    return filteredTagList;
  }

  if (typeof tagValue === 'string' && tagValue.split(',')) {
    tagValue.split(',').forEach((te) => {
      let tagEntry = `${tagName}:${te}`;
      filteredTagList.push(tagEntry);
    });
  } else {
    filteredTagList.push(`${tagName}:${tagValue}`);
  }

  return filteredTagList;
};
